import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ILLProduct } from '../../../shared/models';

@Component({
    selector: 'app-product-accordion-item',
    templateUrl: './product-accordion-item.component.html',
    styleUrls: ['./product-accordion-item.component.scss'],
    standalone: false
})
export class ProductAccordionItemComponent {

  @Input() product: ILLProduct;
  @Input() formProdIndex: ILLProduct;
  @Output() productToDeleteEmitter = new EventEmitter<any>();
  @Output() showPartEmitter = new EventEmitter<any>();

  constructor() { }

  deleteProductItem() {

    this.productToDeleteEmitter.emit(this.formProdIndex);
  }

  showPartItem() {
    this.showPartEmitter.emit(this.formProdIndex);
  }
}
